import { HttpInterceptorFn } from '@angular/common/http';

export const devMockInterceptor: HttpInterceptorFn = (req, next) => {
  // if (
  //   req.url.includes('administration/fleet') &&
  //   req.method === 'OPTIONS' &&
  //   !req.url.includes('drivers')
  // ) {
  //   if (req.url.includes('drivers')) {
  //     return next(
  //       req.clone({
  //         url: 'assets/mock/fleet/drivers.schema.json',
  //         method: 'GET',
  //       }),
  //     );
  //   }
  //   if (req.url.includes('vehicles')) {
  //     return next(
  //       req.clone({
  //         url: 'assets/mock/fleet/vehicles.schema.json',
  //         method: 'GET',
  //       }),
  //     );
  //   }
  //   if (req.url.includes('maintenances')) {
  //     return next(
  //       req.clone({
  //         url: 'assets/mock/fleet/maintenances.schema.json',
  //         method: 'GET',
  //       }),
  //     );
  //   }
  //   if (req.url.includes('expenses')) {
  //     return next(
  //       req.clone({
  //         url: 'assets/mock/fleet/expenses.schema.json',
  //         method: 'GET',
  //       }),
  //     );
  //   }
  //   return next(
  //     req.clone({ url: 'assets/mock/fleet/fleet.schema.json', method: 'GET' }),
  //   );
  // }

  if (req.url.includes('administration/fleet') && req.method === 'GET') {
    // console.log(req.url.split('/'));
    // if (req.url.split('/').length === 4 && req.url.split('/')[3] !== '') {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/fleet_specific.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.split('/')[4] === 'drivers' && req.url.split('/')[3] !== '') {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/drivers_specific.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.split('/')[4] === 'vehicles' && req.url.split('/')[3] !== '') {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/vehicles_specific.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.split('/')[5] === 'maintenances') {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/maintenances_specific.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.split('/')[5] === 'expenses') {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/expenses_specific.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.includes('drivers')) {
    //   return next(
    //     req.clone({ url: 'assets/mock/fleet/drivers.json', method: 'GET' }),
    //   );
    // }
    // if (req.url.includes('vehicles')) {
    //   return next(
    //     req.clone({ url: 'assets/mock/fleet/vehicles.json', method: 'GET' }),
    //   );
    // }
    // if (req.url.includes('maintenances')) {
    //   return next(
    //     req.clone({
    //       url: 'assets/mock/fleet/maintenances.json',
    //       method: 'GET',
    //     }),
    //   );
    // }
    // if (req.url.includes('expenses')) {
    //   return next(
    //     req.clone({ url: 'assets/mock/fleet/expenses.json', method: 'GET' }),
    //   );
    // }
    // return next(
    //   req.clone({ url: 'assets/mock/fleet/fleet.json', method: 'GET' }),
    // );
  }

  return next(req);
};
